import type { TypeCloudflareReason } from './cloudflare-error';

const TUNNEL_PATTERN = /tunnel/i;

export async function detectCloudflareReason(response: Response): Promise<TypeCloudflareReason> {
  const html = await response
    .clone()
    .text()
    .catch(() => '');
  if (TUNNEL_PATTERN.test(html)) {
    return 'tunnel';
  }
  if (html.includes('exceeded resource limits') || html.includes('Worker')) {
    return 'worker';
  }
  return 'unknown';
}
